import React from "react";

export const HelenaLogo = () => {
  return (
    <>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.7721 9.17276L11.7949 10.6591L11.7721 12.2203C11.7721 12.2203 11.8416 13.9889 11.4141 14.7577C10.4909 16.4069 8.33822 18.3506 8.36927 20.375L8.19868 9.2581L11.7721 9.17276Z"
          fill="url(#paint0_linear_12383_12679)"
        />
        <path
          d="M11.7721 9.17276L11.7949 10.6591L11.7721 12.2203C11.7721 12.2203 11.8416 13.9889 11.4141 14.7577C10.4909 16.4069 8.33822 18.3506 8.36927 20.375L8.19868 9.2581L11.7721 9.17276Z"
          fill="url(#paint1_linear_12383_12679)"
        />
        <path
          d="M11.7721 9.17276L11.7949 10.6591L11.7721 12.2203C11.7721 12.2203 11.8416 13.9889 11.4141 14.7577C10.4909 16.4069 8.33822 18.3506 8.36927 20.375L8.19868 9.2581L11.7721 9.17276Z"
          fill="url(#paint2_linear_12383_12679)"
        />
        <path
          d="M4.77016 4.96444L4.79297 7.68521L4.79297 9.2373C4.20057 9.87772 2.62708 11.051 2.19957 11.8198C1.27644 13.469 0.764574 15.3767 0.795629 17.4011L0.625034 4.96444L4.77016 4.96444Z"
          fill="url(#paint3_linear_12383_12679)"
        />
        <path
          d="M4.77016 4.96444L4.79297 7.68521L4.79297 9.2373C4.20057 9.87772 2.62708 11.051 2.19957 11.8198C1.27644 13.469 0.764574 15.3767 0.795629 17.4011L0.625034 4.96444L4.77016 4.96444Z"
          fill="url(#paint4_linear_12383_12679)"
        />
        <path
          d="M4.77016 4.96444L4.79297 7.68521L4.79297 9.2373C4.20057 9.87772 2.62708 11.051 2.19957 11.8198C1.27644 13.469 0.764574 15.3767 0.795629 17.4011L0.625034 4.96444L4.77016 4.96444Z"
          fill="url(#paint5_linear_12383_12679)"
        />
        <path
          d="M4.77016 4.96444L4.79297 7.68521L4.79297 9.2373C4.20057 9.87772 2.62708 11.051 2.19957 11.8198C1.27644 13.469 0.764574 15.3767 0.795629 17.4011L0.625034 4.96444L4.77016 4.96444Z"
          fill="url(#paint6_linear_12383_12679)"
        />
        <path
          d="M19.289 9.08746L19.3359 12.1445C17.1806 12.1775 15.2332 13.054 13.8117 14.4578C13.717 14.5465 13.6282 14.6381 13.5425 14.7354C12.183 16.1993 11.3666 18.1727 11.3997 20.328L8.33981 20.375C8.30874 18.3506 8.8206 16.4429 9.74375 14.7937C10.1713 14.0249 10.6898 13.31 11.2822 12.6696C12.0034 11.8875 12.8366 11.2085 13.7534 10.6591C15.3735 9.68868 17.2646 9.11851 19.289 9.08746Z"
          fill="url(#paint7_linear_12383_12679)"
        />
        <path
          d="M19.289 9.08746L19.3359 12.1445C17.1806 12.1775 15.2332 13.054 13.8117 14.4578C13.717 14.5465 13.6282 14.6381 13.5425 14.7354C12.183 16.1993 11.3666 18.1727 11.3997 20.328L8.33981 20.375C8.30874 18.3506 8.8206 16.4429 9.74375 14.7937C10.1713 14.0249 10.6898 13.31 11.2822 12.6696C12.0034 11.8875 12.8366 11.2085 13.7534 10.6591C15.3735 9.68868 17.2646 9.11851 19.289 9.08746Z"
          fill="url(#paint8_linear_12383_12679)"
        />
        <path
          d="M19.289 9.08746L19.3359 12.1445C17.1806 12.1775 15.2332 13.054 13.8117 14.4578C13.717 14.5465 13.6282 14.6381 13.5425 14.7354C12.183 16.1993 11.3666 18.1727 11.3997 20.328L8.33981 20.375C8.30874 18.3506 8.8206 16.4429 9.74375 14.7937C10.1713 14.0249 10.6898 13.31 11.2822 12.6696C12.0034 11.8875 12.8366 11.2085 13.7534 10.6591C15.3735 9.68868 17.2646 9.11851 19.289 9.08746Z"
          fill="url(#paint9_linear_12383_12679)"
        />
        <path
          d="M11.7451 6.06243L11.792 9.11945C9.63668 9.15252 7.68922 10.029 6.26774 11.4328C6.17309 11.5215 6.0843 11.6131 5.99852 11.7104C4.63905 13.1743 3.82269 15.1477 3.85577 17.303L0.795867 17.35C0.764797 15.3256 1.27666 13.4179 2.19981 11.7687C2.62733 10.9999 3.14584 10.2849 3.73824 9.64453C4.45941 8.86247 5.2927 8.18345 6.20944 7.63406C7.82959 6.66365 9.72065 6.09349 11.7451 6.06243Z"
          fill="url(#paint10_linear_12383_12679)"
        />
        <path
          d="M11.7451 6.06243L11.792 9.11945C9.63668 9.15252 7.68922 10.029 6.26774 11.4328C6.17309 11.5215 6.0843 11.6131 5.99852 11.7104C4.63905 13.1743 3.82269 15.1477 3.85577 17.303L0.795867 17.35C0.764797 15.3256 1.27666 13.4179 2.19981 11.7687C2.62733 10.9999 3.14584 10.2849 3.73824 9.64453C4.45941 8.86247 5.2927 8.18345 6.20944 7.63406C7.82959 6.66365 9.72065 6.09349 11.7451 6.06243Z"
          fill="url(#paint11_linear_12383_12679)"
        />
        <path
          d="M11.7451 6.06243L11.792 9.11945C9.63668 9.15252 7.68922 10.029 6.26774 11.4328C6.17309 11.5215 6.0843 11.6131 5.99852 11.7104C4.63905 13.1743 3.82269 15.1477 3.85577 17.303L0.795867 17.35C0.764797 15.3256 1.27666 13.4179 2.19981 11.7687C2.62733 10.9999 3.14584 10.2849 3.73824 9.64453C4.45941 8.86247 5.2927 8.18345 6.20944 7.63406C7.82959 6.66365 9.72065 6.09349 11.7451 6.06243Z"
          fill="url(#paint12_linear_12383_12679)"
        />
        <path
          d="M15.2929 6.03977C15.1856 5.41943 14.7489 4.6404 13.9186 4.01285C13.5106 3.70268 13.0955 3.50071 12.6875 3.41415V3.11119C13.4963 2.91644 14.2908 2.36823 14.799 1.62527C15.0567 1.25018 15.2213 0.882302 15.2929 0.5H15.5935C15.7152 1.22854 16.2735 2.03642 17.0323 2.57741C17.4045 2.8443 17.791 3.02464 18.1847 3.11119V3.41415C17.3901 3.58006 16.4668 4.29417 16.0087 5.02271C15.7797 5.39058 15.6437 5.7296 15.5935 6.03977H15.2929Z"
          fill="#F2F2F2"
        />
        <path
          d="M15.2929 6.03977C15.1856 5.41943 14.7489 4.6404 13.9186 4.01285C13.5106 3.70268 13.0955 3.50071 12.6875 3.41415V3.11119C13.4963 2.91644 14.2908 2.36823 14.799 1.62527C15.0567 1.25018 15.2213 0.882302 15.2929 0.5H15.5935C15.7152 1.22854 16.2735 2.03642 17.0323 2.57741C17.4045 2.8443 17.791 3.02464 18.1847 3.11119V3.41415C17.3901 3.58006 16.4668 4.29417 16.0087 5.02271C15.7797 5.39058 15.6437 5.7296 15.5935 6.03977H15.2929Z"
          fill="url(#paint13_linear_12383_12679)"
        />
        <path
          d="M15.2929 6.03977C15.1856 5.41943 14.7489 4.6404 13.9186 4.01285C13.5106 3.70268 13.0955 3.50071 12.6875 3.41415V3.11119C13.4963 2.91644 14.2908 2.36823 14.799 1.62527C15.0567 1.25018 15.2213 0.882302 15.2929 0.5H15.5935C15.7152 1.22854 16.2735 2.03642 17.0323 2.57741C17.4045 2.8443 17.791 3.02464 18.1847 3.11119V3.41415C17.3901 3.58006 16.4668 4.29417 16.0087 5.02271C15.7797 5.39058 15.6437 5.7296 15.5935 6.03977H15.2929Z"
          fill="url(#paint14_linear_12383_12679)"
        />
        <path
          d="M15.2929 6.03977C15.1856 5.41943 14.7489 4.6404 13.9186 4.01285C13.5106 3.70268 13.0955 3.50071 12.6875 3.41415V3.11119C13.4963 2.91644 14.2908 2.36823 14.799 1.62527C15.0567 1.25018 15.2213 0.882302 15.2929 0.5H15.5935C15.7152 1.22854 16.2735 2.03642 17.0323 2.57741C17.4045 2.8443 17.791 3.02464 18.1847 3.11119V3.41415C17.3901 3.58006 16.4668 4.29417 16.0087 5.02271C15.7797 5.39058 15.6437 5.7296 15.5935 6.03977H15.2929Z"
          fill="url(#paint15_linear_12383_12679)"
        />
        <path
          d="M15.2929 6.03977C15.1856 5.41943 14.7489 4.6404 13.9186 4.01285C13.5106 3.70268 13.0955 3.50071 12.6875 3.41415V3.11119C13.4963 2.91644 14.2908 2.36823 14.799 1.62527C15.0567 1.25018 15.2213 0.882302 15.2929 0.5H15.5935C15.7152 1.22854 16.2735 2.03642 17.0323 2.57741C17.4045 2.8443 17.791 3.02464 18.1847 3.11119V3.41415C17.3901 3.58006 16.4668 4.29417 16.0087 5.02271C15.7797 5.39058 15.6437 5.7296 15.5935 6.03977H15.2929Z"
          fill="url(#paint16_linear_12383_12679)"
        />
        <path
          d="M16.572 19.4258C16.5123 19.0788 16.2698 18.643 15.8087 18.2919C15.5821 18.1184 15.3516 18.0054 15.125 17.957V17.7875C15.5742 17.6785 16.0154 17.3718 16.2977 16.9562C16.4408 16.7463 16.5322 16.5405 16.572 16.3267H16.7389C16.8065 16.7342 17.1166 17.1862 17.5379 17.4889C17.7446 17.6382 17.9593 17.739 18.1779 17.7875V17.957C17.7367 18.0498 17.2239 18.4493 16.9695 18.8568C16.8423 19.0626 16.7667 19.2523 16.7389 19.4258H16.572Z"
          fill="#F2F2F2"
        />
        <path
          d="M16.572 19.4258C16.5123 19.0788 16.2698 18.643 15.8087 18.2919C15.5821 18.1184 15.3516 18.0054 15.125 17.957V17.7875C15.5742 17.6785 16.0154 17.3718 16.2977 16.9562C16.4408 16.7463 16.5322 16.5405 16.572 16.3267H16.7389C16.8065 16.7342 17.1166 17.1862 17.5379 17.4889C17.7446 17.6382 17.9593 17.739 18.1779 17.7875V17.957C17.7367 18.0498 17.2239 18.4493 16.9695 18.8568C16.8423 19.0626 16.7667 19.2523 16.7389 19.4258H16.572Z"
          fill="url(#paint17_linear_12383_12679)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_12383_12679"
            x1="8.99284"
            y1="20.375"
            x2="8.99284"
            y2="9.1792"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#402CF5" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_12383_12679"
            x1="9.65141"
            y1="16.9465"
            x2="5.78731"
            y2="13.452"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#10F5BE" />
            <stop offset="1" stopColor="#0BBBF3" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_12383_12679"
            x1="10.0001"
            y1="6.33187"
            x2="10.0037"
            y2="20.3668"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#4A25E1" />
            <stop offset="0.463545" stopColor="#7B5AFF" />
            <stop offset="0.927091" stopColor="#FDBEDE" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_12383_12679"
            x1="3.41427"
            y1="17.392"
            x2="3.41427"
            y2="4.87909"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#402CF5" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_12383_12679"
            x1="0.625049"
            y1="11.4067"
            x2="0.625012"
            y2="5.69259"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0BBBF3" />
            <stop offset="1" stopColor="#10F5BE" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_12383_12679"
            x1="2.71699"
            y1="4.87909"
            x2="2.71699"
            y2="14.3122"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0729095" stopColor="#CBBEFD" />
            <stop offset="0.536455" stopColor="#7B5AFF" />
            <stop offset="1" stopColor="#4A25E1" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_12383_12679"
            x1="2.71699"
            y1="4.87909"
            x2="2.71699"
            y2="14.3122"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0729095" stopColor="#FDBEDE" />
            <stop offset="0.536455" stopColor="#7B5AFF" />
            <stop offset="1" stopColor="#4A25E1" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_12383_12679"
            x1="8.3557"
            y1="20.375"
            x2="16.6904"
            y2="10.1836"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#402CF5" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_12383_12679"
            x1="8.33391"
            y1="20.375"
            x2="12.8787"
            y2="10.059"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#10F5BE" />
            <stop offset="1" stopColor="#0BBBF3" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_12383_12679"
            x1="19.336"
            y1="9.10176"
            x2="8.33391"
            y2="20.375"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FDBEDE" />
            <stop offset="0.463545" stopColor="#7B5AFF" />
            <stop offset="0.927091" stopColor="#4A25E1" />
          </linearGradient>
          <linearGradient
            id="paint10_linear_12383_12679"
            x1="0.0459498"
            y1="19.3694"
            x2="12.0922"
            y2="5.69959"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#EFF7FD" />
            <stop offset="1" stopColor="#402CF5" />
          </linearGradient>
          <linearGradient
            id="paint11_linear_12383_12679"
            x1="0.780241"
            y1="17.3409"
            x2="5.33502"
            y2="7.03374"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0BBBF3" />
            <stop offset="1" stopColor="#10F5BE" />
          </linearGradient>
          <linearGradient
            id="paint12_linear_12383_12679"
            x1="-2.3383"
            y1="20.8081"
            x2="12.3247"
            y2="6.06762"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#4A25E1" />
            <stop offset="0.463545" stopColor="#7B5AFF" />
            <stop offset="0.927091" stopColor="#FDBEDE" />
          </linearGradient>
          <linearGradient
            id="paint13_linear_12383_12679"
            x1="16.2842"
            y1="1.74945"
            x2="14.07"
            y2="4.87356"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#EFF7FD" />
            <stop offset="1" stopColor="#402CF5" />
          </linearGradient>
          <linearGradient
            id="paint14_linear_12383_12679"
            x1="17.5528"
            y1="1.63576"
            x2="15.936"
            y2="5.56861"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#10F5BE" />
            <stop offset="1" stopColor="#0BBBF3" />
          </linearGradient>
          <linearGradient
            id="paint15_linear_12383_12679"
            x1="15.4255"
            y1="6.03978"
            x2="15.4255"
            y2="0.504033"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#4A25E1" />
            <stop offset="0.463545" stopColor="#7B5AFF" />
            <stop offset="0.927091" stopColor="#CBBEFD" />
          </linearGradient>
          <linearGradient
            id="paint16_linear_12383_12679"
            x1="16.6271"
            y1="1.39277"
            x2="13.7195"
            y2="4.70167"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0729095" stopColor="#FDBEDE" />
            <stop offset="1" stopColor="#7B5AFF" />
          </linearGradient>
          <linearGradient
            id="paint17_linear_12383_12679"
            x1="17.3129"
            y1="16.8261"
            x2="15.6848"
            y2="18.6654"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0729095" stopColor="#FDBEDE" />
            <stop offset="1" stopColor="#7B5AFF" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};
